import { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { user_login } from "../../api/Auth"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Forgot_Password = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ password: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Handle input change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData?.password?.length < 8) {
            setError("The password field must be at least 8 characters.")
            setLoading(false)
            return
        }
        setLoading(true);
        setError("");

        const formDataToSend = new FormData();
        formDataToSend.append("password", formData.password);

        try {
            const response = await user_login(formDataToSend); // Use global function
            if (response?.token) {
                localStorage.setItem("token", response.token);
                localStorage.setItem("user", JSON.stringify(response.data));
                localStorage.setItem("is_user_active", "true");
                toast.error("Your password has been successfully reset!");
                navigate("/home");
            } else {
                setError(response?.error || "Login failed. Please try again.");
            }
        } catch (error) {
            setError("An unexpected error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Header />
            {/* <-------- ToastContainer ------------> */}
            <ToastContainer style={{ marginTop: "120px" }} />
            <section className="relative overflow-hidden py-10 md:py-24">
                <div className="absolute inset-0 -z-10 bg-[#111315]"></div>
                <div className="absolute inset-0 -z-10 theme-hero-bg"></div>
                <div className="absolute inset-0 -z-10 theme-grid-overlay" />
                <div className="mx-auto max-w-7xl px-6 lg:px-8 relative">
                    <div className="flex flex-col items-center justify-center">
                        <div className="w-full rounded-xl border border-amber-500/20 bg-[#252b33]/95 shadow-2xl backdrop-blur-xl sm:max-w-md">
                            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                                <p className="font-bold leading-tight tracking-tight text-stone-200">
                                    Lost your password? Please enter your email address
                                </p>

                                {error && (
                                    <div className="text-red-400 text-sm font-medium">
                                        {error}
                                    </div>
                                )}

                                <form className="space-y-4" onSubmit={handleSubmit}>
                                    {/* Password Field */}
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-stone-200">
                                            Password
                                        </label>
                                        <input type="password" name="password" className="theme-input" placeholder="••••••••" required value={formData.password} onChange={handleChange} />
                                    </div>

                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-stone-200">
                                            Confirm Password
                                        </label>
                                        <input type="password" name="password" className="theme-input" placeholder="••••••••" required value={formData.password} onChange={handleChange} />
                                    </div>

                                    {/* Submit Button */}
                                    <button type="submit" className="theme-btn-primary w-full px-5 py-2.5 text-center text-sm" disabled={loading}>
                                        {loading ? "Reseting Password..." : "Reseting Password"}
                                    </button>
                                    {/* Signup Link */}
                                    <p className="text-sm text-center text-stone-300">
                                        Already have an account?{" "}
                                        <Link to="/login" className="font-medium text-amber-400 hover:underline">
                                            Sign in
                                        </Link>
                                    </p>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Forgot_Password;
